import { useTranslation } from 'react-i18next'
import { cn } from 'design-system'
import { usePlanAccess } from 'hooks/usePlanAccess'
import { semanticSolidSurfaceClass } from 'helpers/kpiIconClass'

type Props = {
 children: React.ReactNode
}

/**
 * Blocks the tenant app when the account is suspended or subscription expired.
 * Backend remains the source of truth; this mirrors plan_access from /auth/me.
 */
export function TenantAccessGuard({ children }: Props) {
 const { t } = useTranslation()
 const { canOperate, blockMessage } = usePlanAccess()

 if (canOperate) {
 return <>{children}</>
 }

 return (
 <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 text-center">
 <div className={cn('max-w-md rounded-2xl p-8 shadow-sm', semanticSolidSurfaceClass('warning'))}>
 <h1 className="mb-3 text-xl font-bold">{t('common.security.accessDenied')}</h1>
 <p className="text-sm leading-relaxed opacity-90">
 {blockMessage || t('common.security.accessDeniedDefault')}
 </p>
 </div>
 </div>
 )
}
